<script>
	import { fly } from 'svelte/transition';
	import { fade } from 'svelte/transition';

	let ohp = '';
	let dead = '';
	let bench = '';
	let squat = '';

	const WEEK_1 = [0.65, 0.75, 0.85];
	const WEEK_2 = [0.70, 0.80, 0.90];
	const WEEK_3 = [0.75, 0.85, 0.95];
	const WEEK_4 = [0.40, 0.50, 0.60];

	const WARM_UP_TEXT = "Warm up first, then:"
	const DAY_1_TEXT = "Day 1: Overhead Press";
	const DAY_2_TEXT = "Day 2: Deadlift";
	const DAY_3_TEXT = "Day 3: Bench Press";
	const DAY_4_TEXT = "Day 4: Squat";

	let current_week = 1;

	let visible = true;


	function toggle() {
		visible = !visible;
	}

	function check_values()
	{
		if (isNAN(ohp) || isNAN(dead) || isNAN(bench) || isNAN(squat))
			{
			alert("Please enter numeric values for all lifts");
			//else if (ohp > )
			}
	}

	function round5(x)
	{
		return (x % 5) >= 2.5 ? parseInt(x / 5) * 5 + 5 : parseInt(x / 5) * 5;
	}

	function weightToLift(weight, percentage)
	{
		if (isNaN(weight)) return 0;
		let raw = weight * percentage;
		return round5(raw);
	}

	function repNumbers(week, set)
	{
		if (week == 1 || week == 4) return 5; // 5 Reps all sets weeks 1 and 4
		else if (week == 2) return 3; // 3 Reps all sets week 2
		else
		{
			if (set == 1) return 5;
			if (set == 2) return 3;
			if (set == 3) return 1;
		}
	}

	function copyText()
	{
		var copyText = document.getElementById("myInput");
		copyText.select();
		document.execCommand("copy");
		alert("Copied your program URL to clipboard!");
	  } 
	  
	function test()
	{ 
		console.log ('ok');
	}
</script>

<header>
    <nav class="nav">
      <ul>
        <li><a href="https://max.rudyfaile.com/">← Back to One Rep Max Calculator</a></li>
        <li><a href="https://rudyfaile.com/">← Back to rudyfaile.com</a></li>
      </ul>
	</nav>
  </header>

<main>
	{#if visible} <!-- Svelte if -->
	<div class="grid" in:fly="{{ y: -500, duration: 2000 }}" out:fly="{{ y: -500, duration: 500 }}">

		<section class="left-image">
  
		<h1>5/3/1 Calculator</h1>
		<p>The core philosophy behind 5/3/1 revolves around the basic tenets of strength training that have stood the test of time. If you use legitimate 1 rep maxes and follow this program, you will get stronger.</p> <a class="learn" href="https://www.t-nation.com/workouts/531-how-to-build-pure-strength">Learn More</a>
		
		</section>
  
		<section class="right-form">
  
  
		  <h2>Insert your 1 rep maxes:</h2>
		  <a href="https://max.rudyfaile.com/" id="how">(How do I find my 1 rep max?)</a>

		  <form on:submit|preventDefault={toggle}>
			<label for="ohp">Overhead Press:</label>
			<input type="number" bind:value={ohp} placeholder="Overhead One Rep Max" min=1 max=999>
			<label for="dead">Deadlift:</label>
			<input type="number" bind:value={dead} placeholder="Deadlift One Rep Max" min=1 max=999>
			<label for="bench">Bench Press:</label>
			<input type="number" bind:value={bench} placeholder="Bench One Rep Max" min=1 max=999>
			<label for="squat">Squat:</label>
      <input type="number" bind:value={squat} placeholder="Squat One Rep Max" min=1 max=999>
      <input type="submit" value="Create 4 Week Program">
		  </form>
</div>

{:else} <!-- svelte else -->
<br>
<div class="results" in:fly="{{ y: 1000, duration: 2000 }}" out:fly="{{ y: 500, duration: 500 }}">
<div class="save">
<!-- TODO: add URL link saving and stuff -->
<!--<span>Save program URL</span><button onclick='copyText()'>💾</button>-->
<span>&nbsp; &nbsp;  Save to PDF or print </span><button onclick='window.print()'>📄</button>
<span>&nbsp; &nbsp;  Back to generator</span><button on:click={toggle}>🔄</button>
</div>

<h3>Week 1</h3>

<div class='program'>
  <div class='sets'>
  <h4>{DAY_1_TEXT}</h4>
    <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(ohp, WEEK_1[0]) } x { repNumbers(1, 1) } Reps</li>
      <li>Set 2: { weightToLift(ohp, WEEK_1[1]) } x { repNumbers(1, 2) } Reps</li>
      <li>Set 3: { weightToLift(ohp, WEEK_1[2]) } x { repNumbers(1, 3) }+ Reps</li>
    </ul>
</div>

<div class='sets'>
  <h4>{DAY_2_TEXT}</h4>
    <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(dead, WEEK_1[0]) } x { repNumbers(1, 1) } Reps</li>
      <li>Set 2: { weightToLift(dead, WEEK_1[1]) } x { repNumbers(1, 2) } Reps</li>
      <li>Set 3: { weightToLift(dead, WEEK_1[2]) } x { repNumbers(1, 3) }+ Reps</li>
      </ul>
  </div>

  <div class='sets'>
    <h4>{DAY_3_TEXT}</h4>
      <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(bench, WEEK_1[0]) } x { repNumbers(1, 1) } Reps</li>
      <li>Set 2: { weightToLift(bench, WEEK_1[1]) } x { repNumbers(1, 2) } Reps</li>
      <li>Set 3: { weightToLift(bench, WEEK_1[2]) } x { repNumbers(1, 3) }+ Reps</li>
      </ul>
  </div>

  <div class='sets'>
    <h4>{DAY_4_TEXT}</h4>
      <ul>
    <li class='warm-up'>{WARM_UP_TEXT}</li>
    <li>Set 1: { weightToLift(squat, WEEK_1[0]) } x { repNumbers(1, 1) } Reps</li>
    <li>Set 2: { weightToLift(squat, WEEK_1[1]) } x { repNumbers(1, 2) } Reps</li>
    <li>Set 3: { weightToLift(squat, WEEK_1[2]) } x { repNumbers(1, 3) }+ Reps</li>
      </ul>
  </div>
</div>

<h3>Week 2</h3>

<div class='program'>
  <div class='sets'>
  <h4>{DAY_1_TEXT}</h4>
    <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(ohp, WEEK_2[0]) } x { repNumbers(2, 1) } Reps</li>
      <li>Set 2: { weightToLift(ohp, WEEK_2[1]) } x { repNumbers(2, 2) } Reps</li>
      <li>Set 3: { weightToLift(ohp, WEEK_2[2]) } x { repNumbers(2, 3) }+ Reps</li>
    </ul>
</div>

<div class='sets'>
  <h4>{DAY_2_TEXT}</h4>
    <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(dead, WEEK_2[0]) } x { repNumbers(2, 1) } Reps</li>
      <li>Set 2: { weightToLift(dead, WEEK_2[1]) } x { repNumbers(2, 2) } Reps</li>
      <li>Set 3: { weightToLift(dead, WEEK_2[2]) } x { repNumbers(2, 3) }+ Reps</li>
      </ul>
  </div>

  <div class='sets'>
    <h4>{DAY_3_TEXT}</h4>
      <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(bench, WEEK_2[0]) } x { repNumbers(2, 1) } Reps</li>
      <li>Set 2: { weightToLift(bench, WEEK_2[1]) } x { repNumbers(2, 2) } Reps</li>
      <li>Set 3: { weightToLift(bench, WEEK_2[2]) } x { repNumbers(2, 3) }+ Reps</li>
      </ul>
  </div>

  <div class='sets'>
    <h4>{DAY_4_TEXT}</h4>
      <ul>
    <li class='warm-up'>{WARM_UP_TEXT}</li>
    <li>Set 1: { weightToLift(squat, WEEK_2[0]) } x { repNumbers(2, 1) } Reps</li>
    <li>Set 2: { weightToLift(squat, WEEK_2[1]) } x { repNumbers(2, 2) } Reps</li>
    <li>Set 3: { weightToLift(squat, WEEK_2[2]) } x { repNumbers(2, 3) }+ Reps</li>
      </ul>
  </div>
</div>

<h3>Week 3</h3>

<div class='program'>
  <div class='sets'>
  <h4>{DAY_1_TEXT}</h4>
    <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(ohp, WEEK_3[0]) } x { repNumbers(3, 1) } Reps</li>
      <li>Set 2: { weightToLift(ohp, WEEK_3[1]) } x { repNumbers(3, 2) } Reps</li>
      <li>Set 3: { weightToLift(ohp, WEEK_3[2]) } x { repNumbers(3, 3) }+ Reps</li>
    </ul>
</div>

<div class='sets'>
  <h4>{DAY_2_TEXT}</h4>
    <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(dead, WEEK_3[0]) } x { repNumbers(3, 1) } Reps</li>
      <li>Set 2: { weightToLift(dead, WEEK_3[1]) } x { repNumbers(3, 2) } Reps</li>
      <li>Set 3: { weightToLift(dead, WEEK_3[2]) } x { repNumbers(3, 3) }+ Reps</li>
      </ul>
  </div>

  <div class='sets'>
    <h4>{DAY_3_TEXT}</h4>
      <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(bench, WEEK_3[0]) } x { repNumbers(3, 1) } Reps</li>
      <li>Set 2: { weightToLift(bench, WEEK_3[1]) } x { repNumbers(3, 2) } Reps</li>
      <li>Set 3: { weightToLift(bench, WEEK_3[2]) } x { repNumbers(3, 3) }+ Reps</li>
      </ul>
  </div>

  <div class='sets'>
    <h4>{DAY_4_TEXT}</h4>
      <ul>
    <li class='warm-up'>{WARM_UP_TEXT}</li>
    <li>Set 1: { weightToLift(squat, WEEK_3[0]) } x { repNumbers(3, 1) } Reps</li>
    <li>Set 2: { weightToLift(squat, WEEK_3[1]) } x { repNumbers(3, 2) } Reps</li>
    <li>Set 3: { weightToLift(squat, WEEK_3[2]) } x { repNumbers(3, 3) }+ Reps</li>
      </ul>
  </div>
</div>

<h3>Week 4</h3>

<div class='program'>
  <div class='sets'>
  <h4>{DAY_1_TEXT}</h4>
    <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(ohp, WEEK_2[0]) } x { repNumbers(4, 1) } Reps</li>
      <li>Set 2: { weightToLift(ohp, WEEK_2[1]) } x { repNumbers(4, 2) } Reps</li>
      <li>Set 3: { weightToLift(ohp, WEEK_2[2]) } x { repNumbers(4, 3) }+ Reps</li>
    </ul>
</div>

<div class='sets'>
  <h4>{DAY_2_TEXT}</h4>
    <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(dead, WEEK_4[0]) } x { repNumbers(4, 1) } Reps</li>
      <li>Set 2: { weightToLift(dead, WEEK_4[1]) } x { repNumbers(4, 2) } Reps</li>
      <li>Set 3: { weightToLift(dead, WEEK_4[2]) } x { repNumbers(4, 3) }+ Reps</li>
      </ul>
  </div>

  <div class='sets'>
    <h4>{DAY_3_TEXT}</h4>
      <ul>
      <li class='warm-up'>{WARM_UP_TEXT}</li>
      <li>Set 1: { weightToLift(bench, WEEK_4[0]) } x { repNumbers(4, 1) } Reps</li>
      <li>Set 2: { weightToLift(bench, WEEK_4[1]) } x { repNumbers(4, 2) } Reps</li>
      <li>Set 3: { weightToLift(bench, WEEK_4[2]) } x { repNumbers(4, 3) }+ Reps</li>
      </ul>
  </div>

  <div class='sets'>
    <h4>{DAY_4_TEXT}</h4>
      <ul>
    <li class='warm-up'>{WARM_UP_TEXT}</li>
    <li>Set 1: { weightToLift(squat, WEEK_4[0]) } x { repNumbers(4, 1) } Reps</li>
    <li>Set 2: { weightToLift(squat, WEEK_4[1]) } x { repNumbers(4, 2) } Reps</li>
    <li>Set 3: { weightToLift(squat, WEEK_4[2]) } x { repNumbers(4, 3) }+ Reps</li>
      </ul>
  </div>
</div>

</div> <!--white box / results-->
{/if} <!-- end svelte if -->

</main>


<footer>
    <p class="love">This calculator made with 💖 Rudy Faile © 2019</p>
</footer>
